import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import schoolApi from "../../api/schoolApi";
import { Toast, ToastContainer } from "react-bootstrap";

const notifications = [
  {
    id: 1,
    title: "PTM Alert!",
    message: "Dear Rashmi, There will be a parents-teachers meeting.",
    time: "31-08-2023 10:13 PM",
  },
  {
    id: 2,
    title: "Raksha Bandhan Holiday",
    message: "Dear Rashmi, there will be a holiday on 31-08-2023.",
    time: "31-08-2023 10:15 PM",
  },
  {
    id: 3,
    title: "Fee Received!",
    message: "Dear parents, We have received Rs. 7800.",
    time: "26-08-2023 10:45 PM",
  },
  {
    id: 4,
    title: "Sunday Funday",
    message: "Hi Rashmi, there is a Sunday today. Enjoy your weekend!",
    time: "27-08-2023 11:27 AM",
  },
];

const Announcement = () => {
  const [notifications, setNotifications] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [variant, setVariant] = useState("");
  useEffect(() => {
    async function init() {
      console.log("fetchData=>");
      try {
        const token = sessionStorage.getItem("token");
        let userId = null;
        if (token) {
          const { id } = JSON.parse(atob(token.split(".")[1]));
          userId = id;
        }
        console.log("User Id Before API Called =>", userId);
        let data = await schoolApi.getAllAnouncement(userId);
        console.log("1111adata2222>", data);
        setNotifications(data?.result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    init();
  }, []);

  function formatMessage(message) {
    message = message.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");
    message = message.replace(/_(.*?)_/g, "<i>$1</i>");
    message = message.replace(/~(.*?)~/g, "<s>$1</s>");
    message = message.replace(/`(.*?)`/g, "<code>$1</code>");
    message = message.replace(/\n/g, "<br/>");
    return message;
  }

  return (
    <div className="notification-container">
      {/* <ToastContainer className="p-3" position="top-center">
            <Toast
              show={modalShow}
              onClose={() => setModalShow(false)}
              delay={3000}
              bg={variant}
              className="text-white"
              autohide
            ></Toast>
    </ToastContainer> */}
      <Card>
        <Card.Title className="card-title-notification">
          <h3 className="notification-header">Announcements</h3>
        </Card.Title>
      </Card>
      <div className="notification-list mt-4">
        {notifications?.map((notification) => (
          <div className="notification-card" key={notification.id}>
            <div className="notification-icon">
              <i className="fas fa-bullhorn"></i>
            </div>
            <div className="notification-content">
              <h3 className="notification-title">{notification.title}</h3>
              <p className="notification-message" style={{
                            maxHeight: "100px",
                            overflowY: "auto",
                            whiteSpace: "pre-wrap",
                            width:"100%",
                            padding:"3px"
                          }}>
                {notification?.description ? (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: formatMessage(notification.description),
                    }}
                  />
                ) : (
                  "No description available"
                )}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Announcement;
